export const envConstants = {
    REACT_APP_LOKI_AXIOS_BASE_URL: process.env.REACT_APP_LOKI_AXIOS_BASE_URL,
    REACT_APP_TOR_AXIOS_BASE_URL: process.env.REACT_APP_TOR_AXIOS_BASE_URL,

    REACT_APP_OKTA_ISSUER: process.env.REACT_APP_OKTA_ISSUER,
    REACT_APP_OKTA_CLIENT_ID: process.env.REACT_APP_OKTA_CLIENT_ID,
    REACT_APP_OKTA_REDIRECT_URL: process.env.REACT_APP_OKTA_REDIRECT_URL,

    REACT_APP_MAP_ACCESS_TOKEN: process.env.REACT_APP_MAP_ACCESS_TOKEN,
    REACT_APP_MAP_STYLE: process.env.REACT_APP_MAP_STYLE,
    REACT_APP_MAP_OPEN_WEATHER_MAP_KEY: process.env.REACT_APP_MAP_OPEN_WEATHER_MAP_KEY,
    REACT_APP_MAP_ACCUMULATED_PRECIPITATION_COLOR_PALETTE:
        process.env.REACT_APP_MAP_ACCUMULATED_PRECIPITATION_COLOR_PALETTE,
};
